import {Api, apiFetch} from "../_helpers/api";
import {createQueryParameters, to_url} from "../_helpers/utils";

const FeedsRepository = {
    get: (cursor: number = null, page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({cursor: cursor, page: page, per_page: perPage, is_cursor: true});
        return apiFetch(to_url(Api.apiBaseUrl, 'feeds') + query)
            .then(response => {
                return response.json();
            });
    }
};

export default FeedsRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/feedRepository.ts